import { render, staticRenderFns } from "./edit_password.vue?vue&type=template&id=ffd9fbc8&scoped=true&"
import script from "./edit_password.vue?vue&type=script&lang=js&"
export * from "./edit_password.vue?vue&type=script&lang=js&"
import style0 from "./edit_password.vue?vue&type=style&index=0&id=ffd9fbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd9fbc8",
  null
  
)

export default component.exports